import SButton from './s-button'

export default SButton
